var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9987 0.666656C1.55667 0.666656 1.13275 0.842251 0.820187 1.15481C0.507626 1.46737 0.332031 1.8913 0.332031 2.33332V15.6667C0.332031 16.1087 0.507626 16.5326 0.820187 16.8452C1.13275 17.1577 1.55667 17.3333 1.9987 17.3333H11.9987C12.4407 17.3333 12.8646 17.1577 13.1772 16.8452C13.4898 16.5326 13.6654 16.1087 13.6654 15.6667V7.18999C13.6653 6.748 13.4896 6.32414 13.177 6.01166L8.32036 1.15499C8.00788 0.842408 7.58402 0.666751 7.14203 0.666656H1.9987ZM1.58203 2.33332C1.58203 2.22282 1.62593 2.11684 1.70407 2.0387C1.78221 1.96056 1.88819 1.91666 1.9987 1.91666H6.9987V5.66666C6.9987 6.10868 7.17429 6.53261 7.48685 6.84517C7.79941 7.15773 8.22334 7.33332 8.66536 7.33332H12.4154V15.6667C12.4154 15.7772 12.3715 15.8831 12.2933 15.9613C12.2152 16.0394 12.1092 16.0833 11.9987 16.0833H1.9987C1.88819 16.0833 1.78221 16.0394 1.70407 15.9613C1.62593 15.8831 1.58203 15.7772 1.58203 15.6667V2.33332ZM11.482 6.08332H8.66536C8.55486 6.08332 8.44888 6.03942 8.37074 5.96129C8.2926 5.88314 8.2487 5.77716 8.2487 5.66666V2.84999L11.482 6.08332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents-icon.a8598f56eee9015db87406b8e75edd65.svg";
export { ForwardRef as ReactComponent };